module.exports = __webpack_public_path__ + "img/2017-09-05.2d2b1ebc.jpg";